// extracted by mini-css-extract-plugin
module.exports = {"Modal":"_3TbRyfuEBphRErxV1T1sne","ultrawide":"_1pzYITUA_jOR20etp_n52M","mediumwide":"_1R_sleJTj73Lh2wR2vg6Sg"};